import React from "react";
import { FaStar, FaRegStar } from "react-icons/fa";
import "./styles/Rating.css";

class Rating extends React.Component {
  state = { rating: 0 };

  onClick = (value) => {
    this.setState({ rating: value });
    this.props.onClickRating(value);
  };

  render() {
    const isModal = this.props.variant === "modal";
    const btnClass = isModal ? "rating-star-btn" : "btn btn-outline-light";

    return (
      <div className="container-rating">
        {[1, 2, 3, 4, 5].map((value) => (
          <button
            key={value}
            type="button"
            className={`${btnClass}${this.state.rating >= value ? " is-active" : ""}`}
            onClick={() => this.onClick(value)}
            aria-label={`${value} stars`}
          >
            {this.state.rating >= value ? <FaStar /> : <FaRegStar />}
          </button>
        ))}
      </div>
    );
  }
}

export default Rating;
